import React from "react";
import FlightBookingFlowMockup from "../../Components/FlightBookingFlowMockup/FlightBookingFlowMockup.jsx";

/** דף בדיקה בלבד: אותו מוקאפ כמו ב-searchoffer / טיסות */
export default function FlightBookingMockupStandalonePage() {
  return <FlightBookingFlowMockup />;
}
